import type { LobbyParticipant } from '@/entities/meeting'
import { Button } from '@/shared/ui/button'
import { Spinner } from '@/shared/ui/spinner'
import { useAdmitGuest, useLobby } from '../model/use-admit-guests'

interface AdmitGuestsPanelProps {
  meetingId: string
}

// Очередь lobby: гости по ссылке и — в закрытом звонке — сотрудники. Впускает
// любой участник-сотрудник, по одному.
export function AdmitGuestsPanel({ meetingId }: AdmitGuestsPanelProps) {
  const { data, isLoading } = useLobby(meetingId)
  const admit = useAdmitGuest(meetingId)
  const waiting: LobbyParticipant[] = data ?? []

  if (isLoading) return <Spinner label="Загрузка очереди" />

  if (waiting.length === 0)
    return <p className="text-sm text-text-secondary">Никто не ожидает входа</p>

  return (
    <ul className="flex flex-col gap-2">
      {waiting.map((guest) => (
        <li
          key={guest.participantId}
          className="flex items-center justify-between gap-3 rounded-control border border-border-default px-3 py-2"
        >
          <span className="flex min-w-0 flex-col">
            <span className="truncate text-sm text-text-primary">{guest.name}</span>
            <span className="text-xs text-text-tertiary">
              {guest.kind === 'guest' ? 'Гость по ссылке' : 'Сотрудник'}
            </span>
          </span>
          {/* Ждёт только та строка, которую впускают: очередь из нескольких
              человек пропускается подряд, без паузы на каждый запрос. */}
          <Button
            size="sm"
            onClick={() => admit.mutate(guest.participantId)}
            disabled={admit.isPending && admit.variables === guest.participantId}
          >
            Впустить
          </Button>
        </li>
      ))}
    </ul>
  )
}
